import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { threadType } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';
import { isDraftThreadActive, resolvedMainThreadDraftProjectId } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';

export const composerDraftKey = (state) => {
  const threadId = activeThreadId(state);
  const type = threadId ? threadType(state, threadId) : '';

  if (type === 'schedule' || type === 'schedule_run') {
    return 'schedule-builder:new';
  }
  if (type === 'trigger' || type === 'trigger_run') {
    return 'trigger-builder:new';
  }

  if (isDraftThreadActive(state)) {
    const projectId = resolvedMainThreadDraftProjectId(state) || 'home';
    return `new-thread:project:${projectId}`;
  }

  return threadId ? `thread:${threadId}` : 'active';
};
